export default {
  error_messages: {
    failed_to_fetch_orders: 'Caricamento dati fallito. Clicca sull\'icona "aggiorna" o riprova tra 1 minuto.',
    something_went_wrong: 'Qualcosa è andato storto, riprova.',
  },
};
